import {
  usePoiImageCaptionMutation,
  SelectedPointOfInterestDocument,
} from '@/__generated__/graphql';

export function usePoiAttachmentCaption() {
  const [poiImageCaption, { data, loading, error }] = usePoiImageCaptionMutation();

  const updatePoiAttachmentCaption = async (
    pointOfInterestId: string,
    uuid: string | undefined,
    poiAttachmentId: string,
    caption?: string
  ) => {
    if (!caption) return;
    return poiImageCaption({
      variables: {
        input: {
          pointOfInterestId,
          uuid,
          poiAttachmentId,
          caption,
          lastModifiedFor: 'Update attachment caption',
        },
      },
      refetchQueries: [SelectedPointOfInterestDocument],
    });
  };

  return { updatePoiAttachmentCaption, data, loading, error };
}
